import { styled, Grid } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { formatMoney } from '../../../utils/stringUtils.js';

const Container = styled('div')({
    width: 340,
    marginLeft: 'auto',
    marginRight: 'auto',
    '.row': {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '7.5px 0',
        ':nth-last-of-type(2)': {
            paddingBottom: 20,
        },
    },
    '.total-row': {
        fontWeight: 600,
        borderTop: `1px solid ${brandclub_colors.blueWhiteBorder}`,
        padding: '20px 0 15px',
    },
});
const RewardTable = ({ rows, containerStyle = {} }) => {
    const totalRewards = rows.reduce((acc, [, amount]) => acc + amount, 0);
    return (React.createElement(Container, { style: containerStyle },
        rows.map((row, index) => (React.createElement(Grid, { key: index, container: true, className: "row" },
            React.createElement(Grid, { item: true }, row[0]),
            React.createElement(Grid, { item: true }, formatMoney(row[1]))))),
        React.createElement(Grid, { container: true, className: "row total-row" },
            React.createElement(Grid, { item: true }, "Total rewards"),
            React.createElement(Grid, { item: true }, formatMoney(totalRewards)))));
};

export { RewardTable };
//# sourceMappingURL=RewardTable.js.map
